export const getVerticalFooterData = () => [];
